export default __webpack_public_path__ + "static/media/forest-night.fb693676.svg";